export const ADD_ALERT = 'ADD_ALERT';
export const CHANGE_TAB = 'CHANGE_TAB';
export const CLEAR_ALERT = 'CLEAR_ALERT';
export const CLEAR_EMAILS = 'CLEAR_EMAILS';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_MODAL = 'OPEN_MODAL';
export const UPDATE_EMAILS = 'UPDATE_EMAILS';
export const UPDATE_FB_FRIENDS = 'UPDATE_FB_FRIENDS';
export const UPDATE_FB_FRIEND_FOLLOWING_STATUS =
  'UPDATE_FB_FRIEND_FOLLOWING_STATUS';
export const UPDATE_INVITED_EMAILS_LIST = 'UPDATE_INVITED_EMAILS_LIST';

export default {
  ADD_ALERT,
  CHANGE_TAB,
  CLEAR_ALERT,
  CLOSE_MODAL,
  OPEN_MODAL,
  UPDATE_EMAILS,
  UPDATE_FB_FRIENDS,
  UPDATE_FB_FRIEND_FOLLOWING_STATUS,
  UPDATE_INVITED_EMAILS_LIST
};
